function colorChannels(value) {
    return [
        Number.parseInt(value.slice(1, 3), 16),
        Number.parseInt(value.slice(3, 5), 16),
        Number.parseInt(value.slice(5, 7), 16),
    ];
}

export function recolorQrCode(src, theme) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => {
            try {
                const canvas = document.createElement("canvas");
                canvas.width = image.naturalWidth || image.width;
                canvas.height = image.naturalHeight || image.height;
                const context = canvas.getContext("2d", {
                    willReadFrequently: true,
                });
                context.drawImage(image, 0, 0);
                const imageData = context.getImageData(
                    0,
                    0,
                    canvas.width,
                    canvas.height
                );
                const foreground = colorChannels(theme.foreground);
                const background = colorChannels(theme.background);
                for (let index = 0; index < imageData.data.length; index += 4) {
                    const alpha = imageData.data[index + 3];
                    const luminance =
                        imageData.data[index] * 0.2126 +
                        imageData.data[index + 1] * 0.7152 +
                        imageData.data[index + 2] * 0.0722;
                    const target =
                        alpha > 16 && luminance < 144
                            ? foreground
                            : background;
                    imageData.data[index] = target[0];
                    imageData.data[index + 1] = target[1];
                    imageData.data[index + 2] = target[2];
                    imageData.data[index + 3] = 255;
                }
                context.putImageData(imageData, 0, 0);
                resolve(canvas.toDataURL("image/png"));
            } catch (error) {
                reject(error);
            }
        };
        image.onerror = reject;
        image.src = src;
    });
}
